// extracted by mini-css-extract-plugin
export var text = "_a0-0";